import { MeetingsData } from '@services/hooks/dashboard/useMeetingsQuery';

export interface IDashboardMeeting {
	id?: string;
}

export interface IQrModal {
	modalClose: () => void;
	meetingData?: MeetingsData;
	qrId?: string;
	isCloseVisible?: boolean;
}

export const TodaysMeetingStatus = 'MAR(Today Meeting)';
